/** /my-coaching/business/nova/assets — the My assets list. */

import { createFileRoute } from "@tanstack/react-router";

import { MyAssetsPage } from "~/components/nova/assets/my-assets-page";
import { visibleFeaturesQueryOptions } from "~/lib/functions/features";
import { callsAndLinksQueryOptions } from "~/lib/queries/callsAndLinksQuery";
import { placementVideosQueryOptions } from "~/lib/queries/learningQuery";
import { novaAssetsQueryOptions } from "~/lib/queries/novaAssetsQuery";

export const Route = createFileRoute(
  "/_user/my-coaching/business/nova/assets/",
)({
  staticData: { title: "My assets" },
  loader: async ({ context }) => {
    const userId = context.user.clerkUserId;
    // The prefetch is an optimisation — it hands SSR the rows — not the page's
    // data source: the component reads the same query itself. Rejecting here
    // would replace the page's own "Couldn't load your assets" (and the retry
    // behind it) with the router's error boundary, for a failure the component
    // already knows how to recover from.
    await Promise.all([
      context.queryClient
        .ensureQueryData(novaAssetsQueryOptions(userId))
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(placementVideosQueryOptions())
        .catch(() => undefined),
      context.queryClient
        .ensureQueryData(callsAndLinksQueryOptions())
        .catch(() => undefined),
      // The Coming soon cards open a vote only once these have loaded.
      context.queryClient
        .ensureQueryData(visibleFeaturesQueryOptions)
        .catch(() => undefined),
    ]);
    return { userId };
  },
  component: MyAssetsRoute,
});

function MyAssetsRoute() {
  const { userId } = Route.useLoaderData();

  // The lifecycle comes with the rows rather than from this route's context,
  // so the page branches on the same account the server derived the statuses
  // under.
  return <MyAssetsPage userId={userId} />;
}
